// Uploaded Australian Luxe Peptides brand assets
export const ALP_LOGO =
  'https://customer-assets.emergentagent.com/job_alp-luxury-store/artifacts/m6l40tfk_Untitled%20design.png';

export const ALP_SOCIAL_LOGO =
  'https://customer-assets.emergentagent.com/job_alp-luxury-store/artifacts/us8b8la0_Untitled%20design.png';

export const ALP_BANNER =
  'https://customer-assets.emergentagent.com/job_alp-luxury-store/artifacts/m278qxrm_2D3D06AC-4EB7-4B85-9A8A-9A7B24D2A9CE.png';

// Homepage hero (darker bronze podium shot — blends with matte-black hero overlay)
export const ALP_HERO =
  'https://customer-assets.emergentagent.com/job_alp-luxury-store/artifacts/0chj6jcp_0F1EDCD1-C46A-43F2-BAC3-D209DCE2E56D.png';

export const ALP_VIALS = [
  'https://customer-assets.emergentagent.com/job_alp-luxury-store/artifacts/sovgciev_9A9B11FB-B4C6-420D-9E04-CC778C6B0D24.png',
  'https://customer-assets.emergentagent.com/job_alp-luxury-store/artifacts/jdp4oxxm_82FBD83C-38DB-4824-AEA2-C66B11D75019.png',
  'https://customer-assets.emergentagent.com/job_alp-luxury-store/artifacts/4wysr03h_2FA9746E-81ED-4EF6-A36F-24874FE29146.png',
];
